export default {
  settings: {
    'endpointsSectionTitle': 'Szolgáltatási végpontok (URI or teljes URL)',
    'language': 'Nyelv',
    'appLocale': 'Az alkalmazás nyelve',
    'unit': 'Mértékegység',
    'areaUnit': 'Terület-mértékegység',
    'saveToLocalStorage': 'Mentés a böngészőmbe',
    'routeInstructions': 'Útvonaltervezési utasítások',
    'randomizedIsochroneColors': 'Véletlenszerű izokronvonal-színek',
    'distanceMarkers': 'Távolságjelölők',
    'elevationProfile': 'Magassági profil',
    'mapSettings': 'Térképnézet és további információk',
    'defaultMapSettingsRestored': 'Alapértelmezett térképbeállítások visszaállítva és mentve',
    'endpointsTitle': {
      'directions': 'Útirányok',
      'isochrones': 'Izokron vonalak',
      'geocodeSearch': 'Geokód keresése',
      'autocomplete': 'Geokód automatikus kiegészítése',
      'pois': 'Érdekes helyek (POI-k)',
      'reverseGeocode': 'Geokód megfordítása'
    },
    'apiKey': 'API-kulcs',
    'customApiKey': 'Egyedi API-kulcs',
    'apiBaseUrl': 'API alap URL',
    'invalidSettingsValue': 'Érvénytelen beállításérték(ek). Kérjük, ellenőrizze a mezőket vagy állítsa vissza az alapértelmezett értékeket',
    'restoreDefaults': 'Alapértelmezett értékek visszaállítása',
    'advanced': 'Speciális',
    'mapSettingsSaved': 'Térképbeállítások mentve',
    'alwaysFitBounds': 'Mindig igazítsa ki a térképnagyságát, ha az útvonal változik',
    'routeExtraInfo': 'További információk az útvonalról',
    'mapViewOptions': 'Térképnézet beállításai',
    'advancedSettingsWarning': 'Ne módosítsa az alábbi beállításokat, ha nem tudja, mit csinál!',
    'customOverlayerTileProviderUrl': 'Egyedi fedőréteg-szolgáltató URL-je',
    'customTileProviderUrl': 'Egyedi térképmozaik-szolgáltató URL-je',
    'defaultTilesProvider': 'Alapértelmezett térképmozaik-szolgáltató',
    'customTileProviderUrlHint': 'https://domain.tld/path/{z}/{x}/{y}.ext?optionalKey=value',
    'prioritizeSearchingForNearbyPlaces': 'Közeli helyek előnyben részesítése keresésnél',
    'defaultProfile': 'Alapértelmezett profil',
    'compressDataUrlSegment': 'A /data/ utáni URL-szakasz tömörítése',
    'autoFitHighlightedBounds': 'Megjelenített térképnézet automatikus igazítása',
    'reloadToApplyLanguageChangeTitle': 'Újra be kell tölteni az alkalmazást',
    'reloadToApplyLanguageChangeText': 'A nyelvváltás teljes körű alkalmazásához újra be kell tölteni az alkalmazást. Újratölti most?',
    'resetShownOnceTooltips': 'Elemleírások ismételt megjelenítése az alkalmazás betöltésekor',
    'convertStopAfterRouteEndingToDestination': 'Az útvonal vége (úticél) utánra hozzáadott megálló automatikus átalakítása új úticéllá',
    'skipAllSegments': 'egyenes útvonal minden szakasznál',
    'useStopOptimization': 'Útvonal optimalizálása, amikor húzással adnak hozzá megállót'
  }
}
